import React from 'react';
export function ProductIntro() {
  return <section className="py-16 px-4 relative overflow-hidden bg-light-pink" data-id="element-328">
      <div className="absolute inset-0 bg-pink-200 opacity-20 transform -skew-y-3" data-id="element-329"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-330">
        <div className="inline-block bg-teal-400 text-white font-bold px-6 py-2 rounded-full mb-6 text-sm md:text-base uppercase tracking-widest shadow-sm" data-id="element-331">
          The ultimate solution
        </div>

        <h2 className="text-4xl md:text-6xl font-bold text-magenta mb-8 drop-shadow-sm" data-id="element-332">
          🪄 INTRODUCING: MAGIC PARTY KIT
        </h2>

        <p className="text-2xl font-bold text-teal-600 mb-8" data-id="element-333">
          The most complete printable kit on the market.
        </p>

        <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-pink-200 mb-10" data-id="element-334">
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-335">
            <strong className="text-magenta text-2xl" data-id="element-336">
              +10,000 professional designs
            </strong>
            , customizable and ready to print — featuring all the characters
            your kids love, tools to edit from your phone, and step-by-step
            tutorials.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-lg font-bold text-pink-700" data-id="element-337">
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-338">
            <span data-id="element-339">🛍️</span> One purchase
          </div>
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-340">
            <span data-id="element-341">⚡</span> Instant access
          </div>
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-342">
            <span data-id="element-343">🎉</span> Unlimited parties
          </div>
        </div>
      </div>
    </section>;
}